function SvgComponent(props: any) {

    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <path
            d="M10.97 1.893a1.5 1.5 0 012.06 0l7.267 6.868c.45.425.703 1.017.703 1.635v8.355a2.25 2.25 0 01-2.25 2.25h-3a2.25 2.25 0 01-2.25-2.251V15a.75.75 0 00-.75-.75h-1.5a.75.75 0 00-.75.75v3.75A2.25 2.25 0 018.25 21h-3A2.25 2.25 0 013 18.75v-8.355c0-.618.255-1.21.705-1.635l7.264-6.87v.003zM12 2.982l-7.266 6.87a.75.75 0 00-.234.543v8.355a.75.75 0 00.75.75h3a.75.75 0 00.75-.75V15a2.25 2.25 0 012.25-2.25h1.5A2.25 2.25 0 0115 15v3.75a.75.75 0 00.75.75h3a.75.75 0 00.75-.75v-8.355a.75.75 0 00-.234-.545L12 2.982z"
            fill={props.isHover ? '#F2C94C' : '#ffffff'}
        />
        </svg>
    )
}
  
  export default SvgComponent